import { DiscountTypes } from "graphql.generated";

export const jobMutateDiscountsInitialState = {
  discountName: undefined as string | undefined,
  amount: undefined as number | undefined,
  eventIds: [] as string[],
  discountType: undefined as DiscountTypes | undefined,
  code: undefined as string | undefined,
} as const;
